import React from 'react';
import { B } from '../constants';
import { tripTemplates } from '../data/templates';

export default function TemplateSelectorModal({ onClose, onSelect }) {
  const cardStyle = {
    background: '#f9f9f9',
    borderRadius: 12,
    padding: 16,
    cursor: 'pointer',
    transition: 'all 0.2s',
    border: '2px solid transparent',
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white', borderRadius: 20, padding: 28, maxWidth: 600, width: '90%',
        maxHeight: '85vh', overflow: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, margin: 0 }}>
            📋 Trip Templates
          </h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer' }}>×</button>
        </div>

        <p style={{ color: B.muted, marginBottom: 20, fontSize: 14 }}>
          Choose a template to get started quickly. You can customize it after.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {tripTemplates.map(template => (
            <div
              key={template.id}
              onClick={() => onSelect(template)}
              style={cardStyle}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = B.forest}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'transparent'}
            >
              <div style={{ fontSize: 32, marginBottom: 8 }}>{template.icon}</div>
              <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4, fontFamily: "'Montserrat',sans-serif" }}>
                {template.name}
              </h3>
              <p style={{ fontSize: 13, color: B.muted, margin: 0 }}>{template.description}</p>
              <div style={{ fontSize: 12, color: B.forest, marginTop: 8 }}>
                {template.days.length} days
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
